<div class="wrapper-logs">
    <app-advanced-gridview
        [dataSource]="dataSource"
        [size]="size"
        [model]="filteredTableModel"
        [menuItems]="menuItems"
        [contextualMenu]="true"
        (menuClicked)="onAction($event)"></app-advanced-gridview>
</div>
